<template>
  <div class="container">
    <div class="revive-top">
      <spot :title="'复活请求'"></spot>
      <div class="tag">过五关斩六将</div>
    </div>
    <div class="tabSty">
      <div
        :class="[{ activeSty: active == idx }, 'tab']"
        v-for="(val, idx) in tabs"
        :key="idx"
        @click="checkId(val, idx)"
      >
        {{ val }}
      </div>
    </div>
    <div class="done" v-if="active == 0">
      <div class="listSty" v-if="reviveList.length > 0">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          :offset="2"
          @load="onLoad"
        >
          <div class="cellSty" v-for="item in reviveList" :key="item.id">
            <div class="tle">{{ item.real_name }}请求复活</div>
            <div class="intion">
              <div class="linSty">
                止步{{ item.level_name }}，{{ item.expire }}过期
              </div>
              <div>今日第{{ item.today_cnt }}次闯关</div>
              <div class="helpTo" @click="isRevive(item)">复活TA</div>
            </div>
          </div>
        </van-list>
        <div class="allIn" @click="isRevive('')">全部复活</div>
      </div>
      <Empty :word="'暂无求助信息'" v-else></Empty>
    </div>
    <div class="done" v-if="active == 1">
      <div class="hisSty" v-if="reviveList.length > 0">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          :offset="2"
          @load="onLoad"
        >
          <div class="cellSty" v-for="item in reviveList" :key="item.id">
            <div class="divFlex">
              <div class="nameSty">{{ item.real_name }}</div>
              <div>
                {{
                  item.round_challenge_state == 1
                    ? "闯关成功"
                    : item.round_challenge_state == 2 || item.revive_state == 3
                    ? item.level_name + "闯关失败"
                    : item.round_challenge_state == 4
                    ? "闯关结束"
                    : "闯关进行中"
                }}
              </div>
            </div>
            <div v-if="item.revive_state == 3">
              <span>{{ item.expire }} 未复活，已失效</span>
            </div>
            <div v-else>
              <span v-if="item.revive_state !== 0">{{ item.handle_time }}</span>
              <span>{{ item.level_name }}复活</span>
              <span v-if="item.revive_state !== 0">（{{ item.category == 1 ? "好友" : item.op_name }}）</span>
            </div>
          </div>
        </van-list>
      </div>
      <Empty :word="'暂无记录'" v-else></Empty>
    </div>
  </div>
</template>

<script>
import spot from "./components/spot.vue";
import {
  revivependingprocessing,
  reviveuser,
  revivehistoryrecord,
} from "@/api/squirrelCup";
import { List, Cell, Toast } from "vant";
import Empty from "./components/Empty.vue";

export default {
  data() {
    return {
      active: 0,
      tabs: ["待处理", "历史记录"],
      page: {
        pageIndex: 0,
        pageSize: 10,
      },
      loading: false,
      finished: false,
      reviveList: [],
      total: null,
      userInfo: {},
    };
  },
  components: {
    spot,
    [List.name]: List,
    [Cell.name]: Cell,
    Empty,
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfoId"));
    document.title = "复活处理";
    // this.queryRevive();
    this.onLoad();
    // this.revivehistoryList();
  },
  methods: {
    queryRevive() {
      let pkParams = JSON.parse(localStorage.getItem("pkParams"));
      let paramDat = {
        ...this.page,
        param: {
          season_id: pkParams.lastSeasonTagId, //赛季ID
          service_id: pkParams.currentCampusId, //服务中心ID
          agentUserId: Number(this.userInfo.agentUserId),
        },
      };
      revivependingprocessing(paramDat).then((res) => {
        this.total = res.data.count;
        this.reviveList = this.reviveList.concat(res.data.list);
        this.loading = false;
        // if (res.data.body.length  < 10) return (this.finished = true);

        if (this.reviveList.length >= this.total) return (this.finished = true);
      });
    },
    // 复活记录
    revivehistoryList() {
      let pkParams = JSON.parse(localStorage.getItem("pkParams"));

      let paramDat = {
        ...this.page,
        param: {
          service_id: Number(pkParams.currentCampusId),
          season_id: pkParams.lastSeasonTagId,
          agentUserId: Number(this.userInfo.agentUserId),
        },
      };
      revivehistoryrecord(paramDat).then((res) => {
        this.total = res.data.count;
        this.reviveList = this.reviveList.concat(res.data.list);
        this.loading = false;
        // if (res.data.body.length  < 10) return (this.finished = true);

        if (this.reviveList.length >= this.total) return (this.finished = true);
      });
    },
    // 复活确认
    reviveuserList(val) {
      let pkParams = JSON.parse(localStorage.getItem("pkParams"));
      let userInfo = JSON.parse(localStorage.getItem("userInfoId"));
      let param = {
        service_id: Number(pkParams.currentCampusId),
        season_id: pkParams.lastSeasonTagId,
        agentUserId: Number(userInfo.agentUserId),
        source: 2,
        account_list: val.account_id || "",
        id: val ? String(val.id) : "all",
      };
      reviveuser({ param }).then((res) => {
        if (val) {
          Toast("复活成功");
        } else {
          Toast("全部复活中，需要些时间，稍后来查看结果哦");
        }
        this.queryRevive();
      });
    },
    isRevive(val) {
      this.reviveuserList(val);
      this.reviveList = [];
    },
    checkId(item, idx) {
      this.active = idx;
      this.page.pageIndex = 0;

      this.reviveList = [];
      this.finished = false;
      this.onLoad();
    },
    onLoad() {
      this.page.pageIndex++;
      if (this.active === 0) {
        this.queryRevive();
      } else {
        this.revivehistoryList();
      }
    },
  },
};
</script>
<style scoped lang="less">
.revive-top {
  font-size: 34px;
  color: #323232;
  font-weight: bold;
  margin: 0px 48px;
  margin-top: 48px;
  .tag {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 24px;
    margin-bottom: 40px;
  }
}
.listSty {
  height: calc(100vh - 455px);
  overflow: auto;
}
.hisSty {
  height: calc(100vh - 280px);
  overflow: auto;
}
.tabSty {
  margin: 0px 48px;

  display: flex;
  align-items: center;
  font-size: 28px;
  color: #999999;
  .tab {
    margin-right: 96px;
  }
  .activeSty {
    color: #000000;
    font-weight: bold;
    position: relative;
  }
  .activeSty::before {
    content: "";
    position: absolute;
    bottom: -16px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 8px;
    background: #4b8afe;
    border-radius: 4px;
  }
}
.done {
}
.cellSty {
  margin: 58px 16px 32px 16px;
  padding: 0 32px 34px 32px;
  border-bottom: 2px solid rgba(88, 171, 246, 0.2);
  .divFlex {
    display: flex;
    justify-content: space-between;
    font-size: 28px;
    color: #58abf6;
    .nameSty {
      font-size: 32px;
      color: #323232;
      font-weight: bold;
    }
  }
  span {
    font-size: 24px;
    color: #999999;
    margin-right: 16px;
  }
  .linSty {
    line-height: 46px;
  }
}
.tle {
  font-size: 32px;
  color: #323232;
  font-weight: bold;
  margin-bottom: 16px;
}
.intion {
  font-size: 24px;
  color: #999999;
  width: 100%;
  position: relative;
  .helpTo {
    border-radius: 52px;
    border: 2px solid #58abf6;
    color: #58abf6;
    padding: 12px 32px;
    position: absolute;
    bottom: 0px;
    right: 0px;
  }
}
.allIn {
  position: absolute;
  bottom: 66px;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  height: 96px;
  text-align: center;
  line-height: 96px;
  background: #58abf6;
  font-size: 36px;
  color: #ffffff;
  font-weight: bold;
  border-radius: 57px;
}
</style>
